function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgStatistics = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 23 5 L 25 5 L 25 41 L 23 41 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 25.816406 32.777344 L 27.230469 34.191406 L 17.1875 44.230469 L 15.773438 42.816406 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 32.253906 42.824219 L 30.839844 44.238281 L 20.796875 34.195313 L 22.210938 32.78125 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFD8DC"
    },
    d: "M 4 8 L 44 8 L 44 36 L 4 36 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M 3 7 L 45 7 L 45 11 L 3 11 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M 3 35 L 45 35 L 45 37 L 3 37 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M 33 43.5 C 33 44.328125 32.328125 45 31.5 45 C 30.671875 45 30 44.328125 30 43.5 C 30 42.671875 30.671875 42 31.5 42 C 32.328125 42 33 42.671875 33 43.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M 18 43.5 C 18 44.328125 17.328125 45 16.5 45 C 15.671875 45 15 44.328125 15 43.5 C 15 42.671875 15.671875 42 16.5 42 C 17.328125 42 18 42.671875 18 43.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C51162"
    },
    d: "M 31.898438 18.898438 L 26 24.898438 L 20 18.898438 L 11.898438 26.898438 L 14.101563 29.101563 L 20 23.101563 L 26 29.101563 L 34.101563 21.101563 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C51162"
    },
    d: "M 36 24 L 29 17 L 36 17 Z "
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatistics, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/statistics.3baecf8f.svg";
export { ForwardRef as ReactComponent };